"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useControlledQuantityPicker = useControlledQuantityPicker;
var _react = require("react");
var _constants = require("./constants");
/**
 * @param {UseQuantityPickerInnerProps} Props
 * @private
 */ function useControlledQuantityPicker(props) {
    var groupValue = props.groupValue, id = props.id, onChange = props.onChange, setLastIncreased = props.setLastIncreased, triggerClickEvent = props.triggerClickEvent, setTooltipMaxOpen = props.setTooltipMaxOpen, value = props.value, _props_maxValue = props.maxValue, maxValue = _props_maxValue === void 0 ? _constants.DEFAULT_MAX_VALUE : _props_maxValue, _props_maxGroupValue = props.maxGroupValue, maxGroupValue = _props_maxGroupValue === void 0 ? maxValue : _props_maxGroupValue;
    var max = Math.min(maxValue, maxGroupValue);
    var onIncrease = (0, _react.useCallback)(function() {
        triggerClickEvent(id);
        if (typeof value !== 'number') {
            return;
        }
        setLastIncreased(id);
        onChange === null || onChange === void 0 ? void 0 : onChange(value + 1, id, 'increase');
    }, [
        id,
        onChange,
        setLastIncreased,
        triggerClickEvent,
        value
    ]);
    var onDecrease = (0, _react.useCallback)(function() {
        triggerClickEvent(id);
        setLastIncreased('');
        if (typeof value !== 'number') {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(value - 1, id, 'decrease');
    }, [
        id,
        onChange,
        setLastIncreased,
        triggerClickEvent,
        value
    ]);
    var handleInputElement = (0, _react.useCallback)(function(action, inputValue) {
        var source = action === 'change' ? 'input-change' : 'input-blur';
        if (inputValue === '' || inputValue === '-') {
            onChange === null || onChange === void 0 ? void 0 : onChange(inputValue, id, source);
            return;
        }
        var num = Number.parseInt(inputValue, 10);
        if (!Number.isNaN(num)) {
            setTooltipMaxOpen(num > max);
            onChange === null || onChange === void 0 ? void 0 : onChange(num, id, source);
        }
    }, [
        id,
        max,
        onChange,
        setTooltipMaxOpen
    ]);
    var handleChange = (0, _react.useCallback)(function(param) {
        var currentTarget = param.currentTarget;
        triggerClickEvent(id);
        setLastIncreased('');
        handleInputElement('change', currentTarget.value);
    }, [
        handleInputElement,
        id,
        setLastIncreased,
        triggerClickEvent
    ]);
    var handleBlur = (0, _react.useCallback)(function(param) {
        var currentTarget = param.currentTarget;
        triggerClickEvent(id);
        setLastIncreased(id);
        handleInputElement('blur', currentTarget.value);
    }, [
        handleInputElement,
        id,
        setLastIncreased,
        triggerClickEvent
    ]);
    return _object_spread_props(_object_spread({}, props), {
        groupValue: groupValue !== null && groupValue !== void 0 ? groupValue : 0,
        handleBlur: handleBlur,
        handleChange: handleChange,
        id: id,
        onDecrease: onDecrease,
        onIncrease: onIncrease,
        value: value
    });
} //# sourceMappingURL=useControlledQuantityPicker.js.map
